import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './AdminFreelanceMonitorForm.jsx'

export default createSubmit(name)